import { HTMLAttributes, useMemo } from 'react';

import styles from './AdditionalProduct.module.css';
import { MIN_TOUCH_SIZE } from '../constants';
import { Image } from './Image';
import {
  AdditionalProductFragment,
  VariantFragment,
} from '../graphql/generated/graphql';

interface Props extends HTMLAttributes<HTMLImageElement> {
  additionalProduct: AdditionalProductFragment;
  selectedVariant?: VariantFragment | null;
}

export const AdditionalProduct = ({
  additionalProduct,
  selectedVariant,
  ...imageProps
}: Props) => {
  const shoppable = useMemo(
    () => selectedVariant || additionalProduct,
    [additionalProduct, selectedVariant]
  );
  const image = useMemo(() => {
    // Prioritize all variant image sources before falling back to product images
    if (selectedVariant?.ImageUrl) {
      return { file: null, fileUrl: selectedVariant.ImageUrl };
    }
    if (selectedVariant?.Images?.[0]) {
      return { file: selectedVariant.Images[0], fileUrl: null };
    }
    if (additionalProduct.ImageUrl) {
      return { file: null, fileUrl: additionalProduct.ImageUrl };
    }
    return { file: additionalProduct.Image, fileUrl: null };
  }, [selectedVariant, additionalProduct]);

  return (
    <Image
      {...imageProps}
      className={styles.image}
      file={image.file}
      fileUrl={image.fileUrl}
      sizes={MIN_TOUCH_SIZE}
      alt={image.file?.alternativeText || shoppable.Name}
    />
  );
};
